import { Injectable } from '@angular/core';
import { PRIVACY } from "app/model/privacy.model";

@Injectable()
export class PRIVACYService {
    constructor() { }

    generatePrivacy(privacy: any) {
      //  console.log('PRIVACY CONTENT:',privacy.in_read_and_understood, typeof privacy.in_read_and_understood , privacy.in_read_and_understood);
      return {
        style: 'tableExample',
        table: {
          widths: ['50%', '25%', '25%'],
          body:
            [
              [
                { colSpan: 3, style: "questions", text: 'You have read and understood our Privacy Policy and consent to us using your personal information you provide to us.' },
                '', ''
              ],
              [
                { style: "questions", text: 'Selected' },
                { text: ' ' + (privacy.in_read_and_understood==true? "Yes" : "No"), italics: true, colSpan: 2 }
                , ''
              ],
              [
                { colSpan: 3, text: ' Would you like to be on our mailing list?', style: "questions" },
                '', ''
              ],
              [
                {text: 'Selected', style: "questions"},
                        { text: ' ' + (privacy.in_mailing_list_yes == true?"Yes":"No"), italics: true, colSpan: 2 }
                        , ''
                    ],
                    // [
                    //   {text:'No', style: "questions"},
                    //     { text: ' ' + privacy.in_mailing_list_yes?"":"NO", italics: true, colSpan: 2 }
                    //     , ''
                    // ],
                    [
                        { colSpan: 3, text: ' Your mail address:',style: "questions" },
                        '', ''
                    ],
                    [

                        { text: ' ' + privacy.in_mailing_email, italics: true, colSpan: 3 }
                        , '', ''
                    ],



                ]
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/services/pdf/privacypdf.generation.ts